import { bus } from "@/bus/bus";

/**
 * @description: 用于接收信号的mixin
 * 使用方法：
 * 在需要接收键盘信号的组件中引入该mixin，与keyPressSignalMixin配合使用
 */
const keyPressSlotMixin = {
    data() {
        return {
            currentLineParam: {},
            keydown: false,
        }
    },
    methods: {
        _keyPress(event) {
          if(this.endClickChartFlag != undefined && !this.endClickChartFlag) return
          if(typeof this.activatedFlag != undefined && this.activatedFlag == false) return
            console.log('keyPressSlotMixin: keyPress()');
            if (event.keyCode === 37) {
                this._arrowLeftPressedHandler();
            } else if (event.keyCode === 39) {
                this._arrowRightPressedHandler();
            }
        },
        _arrowLeftPressedHandler() {
            this._keyPressHandler(true);
        },
        _arrowRightPressedHandler() {
            this._keyPressHandler(false);
        },
        _keyPressHandler(isLeft) {
            // console.log('KeyPressSlotMixin::_keyPressHandler()');
            const offset = isLeft ? -1 : 1;
            if (this.PrimarySecondary.isMark) {
                this._drawLineHelper(this.PrimaryLineParam, offset);
            } else {
                this._drawLineHelper(this.SecondaryLineParam, offset);
            }
        },
        _drawLineHelper(lineParam, offset) {
          if(!lineParam){
            return
          }
          const option = this.mychart.getOption();
          let param = lineParam;
          let xIndex = param.xIndex + offset;
          let newParam = {};
          if(option.xAxis[0].type == 'category') {
            newParam.name = option.xAxis[0].data[xIndex];
          } else {
            newParam.name = option.series[param.seriesNameIndex].data[xIndex][0]
          }
          newParam.xIndex = xIndex
          newParam.seriesNameIndex = param.seriesNameIndex
          newParam.seriesName = option.series[param.seriesNameIndex].name;
          newParam.seriesId = option.series[param.seriesNameIndex].id
          newParam.seriesY = option.series[param.seriesNameIndex].data[xIndex];
          newParam.isPrimaryCursor = this.PrimarySecondary.isMark !== undefined ? this.PrimarySecondary.isMark : true;
          this.currentLineParam = newParam;
          this.$emit("chartinfo", this.currentLineParam);
          this.drawLineAndProLine(newParam.name, newParam.seriesNameIndex, newParam);
        }
    },
    mounted() {
        bus.$on('keyDown', this._keyPress);
    },
}

export default keyPressSlotMixin;



// WEBPACK FOOTER //
// ./src/mixins/keyPressSlotMixin.js